import { guardChildNodeByType } from '@utils/ast';
import { convertColorStringToRgb } from '@utils/css';
import { parseCaption } from './util.parse-caption.js';
import { parsePm2Data } from './util.parse-pm2-data.js';

const parseSliderComponent = (node) => {
  const caption = parseCaption(node);
  const pm2 = parsePm2Data(node, caption);
  if (!pm2) {
    return null;
  }
  const slides = Array.from(node.childNodes).filter(guardChildNodeByType("SliderElement")).map(parseSlide).filter((slide) => slide !== null);
  if (slides.length === 0) {
    return null;
  }
  return {
    nodeType: "slider-component",
    id: node.getAttribute("id") ?? void 0,
    pm2,
    meta: {
      caption
    },
    options: {
      bulletType: extractBulletType(node),
      displayTitle: node.getAttribute("showTitle") === "true",
      displayCaption: node.getAttribute("showCaptions") === "true",
      isFramed: node.getAttribute("showFrame") === "true"
    },
    slides
  };
};
function parseSlide(node) {
  var _a, _b;
  const imageSrc = node.getAttribute("src");
  if (!imageSrc) {
    return null;
  }
  const linkHref = node.getAttribute("internalLinkUrl") || node.getAttribute("linkUrl");
  const linkLabel = node.getAttribute("linkText");
  const linkBackgroundColor = node.getAttribute("linkBackground");
  const linkTextColor = node.getAttribute("linkColor");
  return {
    caption: {
      title: extractSliderImageCaptionProperty(node, "title"),
      description: extractSliderImageCaptionProperty(node, "description"),
      authorOrArtist: extractSliderImageCaptionProperty(node, "author"),
      copyright: extractSliderImageCaptionProperty(node, "creditline"),
      year: extractSliderImageCaptionProperty(node, "year"),
      caption: void 0,
      country: void 0,
      duration: void 0,
      numberOfPages: void 0
    },
    image: {
      src: `${process.env["PM2_MEDIA_DOMAIN"]}/${imageSrc}`,
      width: Number(node.getAttribute("imageWidth") || "160"),
      height: Number(node.getAttribute("imageHeight") || "90")
    },
    link: linkHref && linkLabel ? {
      href: linkHref,
      label: linkLabel,
      target: !node.getAttribute("internalLinkUrl") ? "_blank" : void 0,
      color: linkTextColor ? (_a = convertColorStringToRgb(linkTextColor)) == null ? void 0 : _a.toString() : void 0,
      background: linkBackgroundColor ? (_b = convertColorStringToRgb(linkBackgroundColor)) == null ? void 0 : _b.toString() : void 0
    } : void 0
  };
}
function extractBulletType(node) {
  const bulletType = String(node.getAttribute("bulletType"));
  switch (bulletType.toLowerCase()) {
    case "afrundet-kvadrat-med-tal":
      return "square";
    case "cirkul\xE6r-uden-tal":
      return "circle";
    default:
      console.warn(
        `parseSlider.extractBulletType(): Unknown bullet type "${bulletType}", falling back to circle.`
      );
      return "circle";
  }
}
const sliderComponentParsers = {
  slider: parseSliderComponent
};
function extractSliderImageCaptionProperty(node, propertyName) {
  const value = node.getAttribute(propertyName);
  if (!value) {
    return void 0;
  }
  const showInContext = node.getAttribute(`${propertyName}-show-in-context`) === "true";
  const showOutsideContext = node.getAttribute(`${propertyName}-show-out-of-context`) === "true";
  return {
    value,
    showInContext,
    showOutsideContext
  };
}

export { sliderComponentParsers };
//# sourceMappingURL=component.slider.js.map
